import { t } from '@lingui/core/macro'
import { containsDealer } from '@/core/enums/tipo-usuario'
import Yup from '@/core/utils/yup-validation'
import { OptionSelect } from '@/core/utils/types'
import { grupoUsuarioByNomeGql } from '../data/grupo-usuarios'
import { getLabel } from '@/core/utils/global-labels'

export const validationSchema = client => {
  return Yup.object().shape({
    nome: Yup.string()
      .label(t`Nome`)
      .required()
      .test(
        'nome-grupo-usuarios-unique-validation',
        t`O nome já está sendo utilizado`,
        async function nomeAlreadyExistsValidation(value) {
          if (
            !value ||
            (this.parent.id && this.parent.nomeOriginal === value)
          ) {
            return true
          }

          const { data } = await client.query({
            query: grupoUsuarioByNomeGql,
            variables: { nome: value },
            fetchPolicy: 'network-only'
          })

          return !data.grupoUsuariosByNome
        }
      ),
    marcas: Yup.array()
      .label(getLabel('label.marcas'))
      .when('possuiPerfil', (possuiPerfil, schema) => {
        return possuiPerfil?.[0]
          ? schema.min(1, t`Selecione pelo menos um item`).required()
          : schema.notRequired()
      }),
    tiposUsuarios: Yup.array()
      .label(t`Tipos de Usuários`)
      .when('possuiPerfil', (possuiPerfil, schema) => {
        return possuiPerfil?.[0]
          ? schema.min(1, t`Selecione pelo menos um tipo de usuário`).required()
          : schema.notRequired()
      }),

    dealers: Yup.array()
      .label(getLabel('label.dealers'))
      .when(
        ['possuiPerfil', 'tiposUsuarios', 'todosDealers'],
        (values, schema) => {
          if (values?.[2]) return Yup.array().nullable()

          const tipos = (values?.[1] ?? []).map(
            (tipo: OptionSelect) => tipo.value
          )

          return values?.[0] && containsDealer(tipos)
            ? schema.min(1, t`Selecione pelo menos um item`).required()
            : Yup.array().nullable()
        }
      ),
    usuariosManuais: Yup.array()
      .label(t`Usuários`)
      .when('possuiUsuariosManuais', (possuiUsuariosManuais, schema) => {
        return possuiUsuariosManuais?.[0]
          ? schema.min(1, t`Selecione pelo menos um usuário manual`).required()
          : schema.notRequired()
      }),
    cargos: Yup.array()
      .label(t`Cargos`)
      .when('possuiCargos', (possuiCargos, schema) => {
        return possuiCargos?.[0]
          ? schema.min(1, t`Selecione pelo menos um cargo`).required()
          : schema.notRequired()
      }),
    setores: Yup.array()
      .label(t`Setores`)
      .when('possuiSetores', (possuiSetores, schema) => {
        return possuiSetores?.[0]
          ? schema.min(1, t`Selecione pelo menos um setor`).required()
          : schema.notRequired()
      }),
    grupos: Yup.array()
      .label(getLabel('label.grupos'))
      .when('possuiGrupos', (possuiGrupos, schema) => {
        return possuiGrupos?.[0]
          ? schema.min(1, t`Selecione pelo menos um item`).required()
          : schema.notRequired()
      })
  })
}
